import { render, staticRenderFns } from "./SuggestTags.vue?vue&type=template&id=372e77d6&scoped=true"
import script from "./SuggestTags.vue?vue&type=script&lang=js"
export * from "./SuggestTags.vue?vue&type=script&lang=js"
import style0 from "./SuggestTags.vue?vue&type=style&index=0&id=372e77d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372e77d6",
  null
  
)

export default component.exports